var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 154,
    viewBox: "0 0 63 154",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666667 6C0.666667 8.94552 3.05448 11.3333 6 11.3333C8.94552 11.3333 11.3333 8.94552 11.3333 6C11.3333 3.05448 8.94552 0.666667 6 0.666667C3.05448 0.666667 0.666667 3.05448 0.666667 6ZM6 7H10V5H6V7ZM18 7H26V5H18V7ZM34 7H38V5H34V7ZM38 7C39.019 7 40.0221 7.06621 41.0053 7.19445L41.264 5.21126C40.1953 5.07185 39.1058 5 38 5V7ZM46.8039 8.74486C48.6732 9.52003 50.4185 10.5349 52.0015 11.7513L53.2201 10.1655C51.5002 8.84376 49.6029 7.74045 47.57 6.89741L46.8039 8.74486ZM56.2487 15.9985C57.4651 17.5815 58.48 19.3268 59.2551 21.1961L61.1026 20.43C60.2596 18.3971 59.1562 16.4998 57.8345 14.7799L56.2487 15.9985ZM60.8055 26.9947C60.9338 27.9779 61 28.981 61 30H63C63 28.8942 62.9281 27.8047 62.7887 26.736L60.8055 26.9947ZM61 30V33.4444H63V30H61ZM61 40.3333V47.2222H63V40.3333H61ZM61 54.1111V61H63V54.1111H61ZM61 67.8889V74.7778H63V67.8889H61ZM61 81.6667V88.5556H63V81.6667H61ZM61 95.4444V102.333H63V95.4444H61ZM61 109.222V116.111H63V109.222H61ZM61 123V129.889H63V123H61ZM61 136.778V143.667H63V136.778H61ZM61 150.556V154H63V150.556H61Z",
    fill: "#654198"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorPurple);
export default __webpack_public_path__ + "static/media/vectorPurple.69608317a289192cb70bcd82b248a038.svg";
export { ForwardRef as ReactComponent };